import React from 'react';

import CashbackPresenter from '../../../../../presenters/CashbackPresenter';
import Group from '../../../../../components/Group';
import Row from '../../../../../components/Row';
import Column from '../../../../../components/Column';
import Value from '../../../../../components/Value';

const CashbackInfo = (props) => {
  const { cashback } = props;

  const transactionLink = CashbackPresenter.hasPlaidTransaction(cashback)
    ? `/transactions/${CashbackPresenter.plaidTransactionId(cashback)}`
    : '#';

  return (
    <Group>
      <Row>
        <Column>
          <Value attr="date" title="Date">
            {CashbackPresenter.date(cashback)}
          </Value>
          <Value attr="storeName" title="Store name">
            {CashbackPresenter.name(cashback)}
          </Value>
          <Value attr="source" title="Source">
            {CashbackPresenter.sourceReadable(cashback)}
          </Value>
          <Value attr="state" title="State">
            {CashbackPresenter.state(cashback)}
          </Value>
        </Column>
        <Column>
          <Value attr="rate" title="Rate">
            {CashbackPresenter.rateReadable(cashback)}
          </Value>
          <Value attr="amount" title="Amount">
            {CashbackPresenter.amountReadable(cashback)}
          </Value>
          <Value attr="payment_meta" title="Transaction Amount">
            {CashbackPresenter.hasPlaidTransaction(cashback) ? (
              <a href={transactionLink}>
                {CashbackPresenter.transactionAmountReadable(cashback)}
              </a>
            ) : (
              CashbackPresenter.transactionAmountReadable(cashback)
            )}
          </Value>
        </Column>
      </Row>
    </Group>
  );
};

export default CashbackInfo;

CashbackInfo.propTypes = {
  cashback: CashbackPresenter.shape().isRequired,
};
